import * as apicall from "../components/Apicall";

// Asset (vehicle / generic customer asset) printed on each booking's invoice.
// Resolves to { [booking_id]: { kind, type_label, title, fields: [{label, value}] } }.
// Never rejects and never blocks: any failure resolves to {} so the invoice
// still downloads, just without asset blocks.
export const getInvoiceAssets = async (bookingIds = []) => {
  const ids = [...new Set(bookingIds.filter(Boolean))];
  if (ids.length === 0) return {};
  try {
    const res = await apicall.post({ booking_ids: ids }, "ezp_booking_invoice_assets");
    return res?.success && res.data && typeof res.data === "object" ? res.data : {};
  } catch (e) {
    return {};
  }
};
